import { GenerateStyle } from '../generateStyle';

import deep_canvassing from './deep_canvassing';
import glapp from './glapp';

export default {
  deep_canvassing: deep_canvassing,
  glapp: glapp,
} as Record<string, GenerateStyle>;
